import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isKitItemsLoading: false,
  isToolkitsLoading: false,
  isKitItemStatusLoading: false,
  isToolkitStatusLoading: false,
  isToolkitCategoryLoading: false,
  error: null,
  kit_items: null,
  kit_item_statuses: null,
  toolkit_statuses: null,
  toolkits: null,
  toolkitCategories: null,
};

const slice = createSlice({
  name: 'toolkit',
  initialState,
  reducers: {
    // START LOADING
    startKitItemsLoading(state) {
      state.isKitItemsLoading = true;
    },
    startToolkitsLoading(state) {
      state.isToolkitsLoading = true;
    },
    startToolkitCategoryLoading(state) {
      state.isToolkitCategoryLoading = true;
    },
    startKitItemStatusLoading(state) {
      state.isKitItemStatusLoading = true;
    },
    startToolkitStatusLoading(state) {
      state.isToolkitStatusLoading = true;
    },
    // Category,
    // HAS ERROR
    hasError(state, action) {
      state.isKitItemsLoading = false;
      state.isKitItemStatusLoading = false;
      state.isToolkitStatusLoading = false;
      state.isToolkitsLoading = false;
      state.isToolkitCategoryLoading = false;
      state.error = action.payload;
    },
    // GET KIT ITEMS
    setKitItems(state, action) {
      state.isKitItemsLoading = false;
      state.kit_items = action.payload;
    },
    // GET KIT ITEMS
    setKitItemStatuses(state, action) {
      state.isKitItemStatusLoading = false;
      state.kit_item_statuses = action.payload;
    },
    // GET TOOLKITS
    setToolkits(state, action) {
      state.isToolkitsLoading = false;
      state.toolkits = action.payload;
    },
    // GET TOOLKIT STATUSES
    setToolkitStatuses(state, action) {
      state.isToolkitStatusLoading = false;
      state.toolkit_statuses = action.payload;
    },
    // GET TOOLKITS Category
    setToolkitCategory(state, action) {
      state.isToolkitCategoryLoading = false;
      state.toolkitCategories = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startKitItemsLoading,
  startKitItemStatusLoading,
  startToolkitStatusLoading,
  startToolkitsLoading,
  startToolkitCategoryLoading,
  hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getKitItems(params = {}) {
  return async () => {
    dispatch(slice.actions.startKitItemsLoading());
    try {
      const response = await axios.get(`/admin/toolkit/kit_items`, { params: params });
      dispatch(slice.actions.setKitItems(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getKitItemStatus(params = {}) {
  return async () => {
    dispatch(slice.actions.startKitItemStatusLoading());
    try {
      const response = await axios.get(`/admin/toolkit/kit_item_statuses`, { params: params });
      dispatch(slice.actions.setKitItemStatuses(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getToolkitStatus(params = {}) {
  return async () => {
    dispatch(slice.actions.startToolkitStatusLoading());
    try {
      const response = await axios.get(`/admin/toolkit/toolkit_statuses`, { params: params });
      dispatch(slice.actions.setToolkitStatuses(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getAvailableKitItems(params = {}) {
  return async () => {
    dispatch(slice.actions.startKitItemsLoading());
    try {
      const response = await axios.get(`/admin/toolkit/dropdown/available_kit_items`, { params: params });
      dispatch(slice.actions.setKitItems(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getToolkits() {
  return async () => {
    dispatch(slice.actions.startToolkitsLoading());
    try {
      const response = await axios.get(`/admin/toolkit/toolkits`);
      dispatch(slice.actions.setToolkits(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableToolkits() {
  return async () => {
    dispatch(slice.actions.startToolkitsLoading());
    try {
      const response = await axios.get(`/admin/toolkit/dropdown/available_toolkits`);
      dispatch(slice.actions.setToolkits(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getToolkitCategory() {
  return async () => {
    dispatch(slice.actions.startToolkitCategoryLoading());
    try {
      const response = await axios.get(`/admin/toolkit/toolkit_categories`);
      dispatch(slice.actions.setToolkitCategory(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
